import { getAuthStorageKeys, resolveStoragePrefix, storageKey } from '~/utils/storageKey'

/**
 * @description 读取当前运行时的认证存储键名（Cookie / localStorage）
 * @returns {ReturnType<typeof getAuthStorageKeys>}
 */
export function getRuntimeAuthKeys() {
  const config = useRuntimeConfig()
  return getAuthStorageKeys(config.public)
}

/**
 * @description 带项目前缀的存储键 composable
 * @returns {{ prefix: import('vue').ComputedRef<string>, keys: import('vue').ComputedRef<ReturnType<typeof getAuthStorageKeys>>, sk: (key: string) => string }}
 */
export function useStorageKey() {
  const config = useRuntimeConfig()
  const prefix = computed(() => resolveStoragePrefix(config.public))
  const keys = computed(() => getAuthStorageKeys(config.public))
  const sk = (key) => storageKey(key, prefix.value)
  return { prefix, keys, sk }
}
